import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, signOut } from './firebase/firebase'; 

function SignOut() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login'); 
    } catch (error) {
      console.error('Sign Out Error:', error.message);
    }
  };

  return (
    <div className="sign-out-container">
      <button onClick={handleSignOut} className="sign-out-button">
        Sign Out
      </button>
    </div>
  );
}

export default SignOut;